import axios from "../utils/axios";

export const getContactSection = async () => {
    const response = await axios.get('/contact-section');
    return response.data;
};

export const updateContactSection = async (data) => {
    const response = await axios.put('/contact-section', data);
    return response.data;
};
